import { useDispatch, useSelector } from "react-redux";
import { Box, Switch } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import Pagination from '@mui/material/Pagination'
import NoDataImg from '../../../assets/img/no-data.gif'
import NavBar from "../../structure/NavBar"
import { v4 as uuidv4 } from 'uuid'
import { NavBarTop } from "../../structure/NavBarTop"
import { useEffect, useState } from "react";
import InsufficientPermission from "../../custom/InSufficientPermission";
import { updateTopHeader } from "../../../redux/features/common/commonSlice";
import { Link } from "react-router-dom";

export const CountryRoutingList = () => {
    const LOADING_ENABLE = useSelector(state => state?.loading)
    const [page, setPage] = useState(1)
    const dispatch = useDispatch()
    const userData = useSelector(state => state?.userData)
    const [datalist, setDatalist] = useState([])
    const userPermisiions = useSelector(state => state?.permission)
    let currentModulePermission;
    let viewPermission = true;
    let editPermission = true;
    let deletePermissionVal = true;
    let activePermission = true;
    const [callAPi, setCallAPi] = useState('')
    const [pagerecord, setPagerecord] = useState({
        totalItems: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
    })

    useEffect(() => {
        dispatch(updateTopHeader('Routing Manager'))
    }, [])

    const handleChange = (event, value) => {
        setPage(value)
        setPagerecord({
            totalItems: pagerecord?.totalItems,
            totalPages: pagerecord?.totalPages,
            pageNumber: value,
            pageSize: 10
        })
        setCallAPi(uuidv4())
    }

    if (userPermisiions?.modules.length > 0) {
        currentModulePermission = userPermisiions.modules.find((element) => {
            if (element.moduleId === '16') {
                return element
            }
        })?.permissions
        viewPermission = currentModulePermission.find((element) => {
            if (element.name === 'VIEW') {
                return element
            }
        }).isEnable
        editPermission = currentModulePermission.find((element) => {
            if (element.name === 'EDIT') {
                return element
            }
        }).isEnable
        deletePermissionVal = currentModulePermission.find((element) => {
            if (element.name === 'DELETE') {
                return element
            }
        }).isEnable
        activePermission = currentModulePermission.find((element) => {
            if (element.name === 'ACTIVE') {
                return element
            }
        }).isEnable
    }

    return (
        <>
            <NavBar />
            <div className='main-content'>
                <NavBarTop />
                <div className='header'>
                    <div className='logo'>
                        <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                    </div>
                </div>
                {
                    viewPermission ? (
                        <>
                            <div className='container-fluid mt--7'>
                                <div className='row'>
                                    <div className='col text-left'>
                                        <div className='card shadow'>
                                            <div className='card-header border-0'>
                                                <div className='row align-items-center text-left'>
                                                    <div className='col'>
                                                        <h3 className='mb-0'>Country Routing List</h3>
                                                    </div>
                                                    <div className='col text-right'>
                                                        {userData.admin ? (
                                                            <Link
                                                                to={`/add-routing-config`}
                                                                className='btn btn-sm btn-primary text-white'
                                                            >
                                                                <AddIcon />
                                                                Add New
                                                            </Link>
                                                        ) : editPermission ? (
                                                            <Link
                                                                to={`/add-routing-config`}
                                                                className='btn btn-sm btn-primary text-white'
                                                            >
                                                                <AddIcon />
                                                                Add New
                                                            </Link>
                                                        ) : (
                                                            <></>
                                                        )}

                                                        {/* <a href='#!' className='btn btn-sm btn-primary'>
                          See all
                        </a> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='table-responsive'>
                                                {datalist && datalist?.length > 0 ? (
                                                    <>
                                                        <table className='table align-items-center table-flush'>
                                                            <thead className='thead-light'>
                                                                <tr>
                                                                    <th scope='col'>S/No.</th>
                                                                    <th scope='col'>Country Name</th>
                                                                    <th scope='col'>State</th>
                                                                    <th scope='col'>Created At</th>
                                                                    <th scope='col'>Status</th>
                                                                    {
                                                                        (editPermission || deletePermissionVal) &&
                                                                        <th scope='col'>Action</th>
                                                                    }
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {datalist &&
                                                                    datalist?.map((data, i) => {
                                                                        const startIndex =
                                                                            (pagerecord.pageNumber - 1) *
                                                                            pagerecord.pageSize
                                                                        return (
                                                                            <>
                                                                                <tr>
                                                                                    <td>{startIndex + i + 1}</td>
                                                                                    <td>{data?.countryName}</td>
                                                                                    <td>{data?.name}</td>
                                                                                    {
                                                                                        (editPermission || deletePermissionVal) &&
                                                                                        <td className='text-center'>
                                                                                            <div className='dropdown'>
                                                                                                <a
                                                                                                    className='btn btn-sm btn-icon-only text-light'
                                                                                                    href='#'
                                                                                                    role='button'
                                                                                                    data-toggle='dropdown'
                                                                                                    aria-haspopup='true'
                                                                                                    aria-expanded='false'
                                                                                                >
                                                                                                    <i className='fas fa-ellipsis-v' />
                                                                                                </a>
                                                                                                <div
                                                                                                    className='dropdown-menu dropdown-menu-right dropdown-menu-arrow'
                                                                                                    x-placement='bottom-end'
                                                                                                    style={{
                                                                                                        position: 'absolute',
                                                                                                        willChange: 'transform',
                                                                                                        top: '0px',
                                                                                                        left: '0px',
                                                                                                        transform:
                                                                                                            'translate3d(32px, 32px, 0px)'
                                                                                                    }}
                                                                                                >
                                                                                                    {/* {userData.admin ? (
                                              <a
                                                className='dropdown-item cursor'
                                                onClick={() => {
                                                  setShowAddImportDistrict(
                                                    !showAddImportDistrict
                                                  )
                                                  setSelectedStateId(data?.id)
                                                  setSheetIndex(i)
                                                }}
                                              >
                                                Import Districts
                                              </a>
                                            ) : active ? (
                                              <a
                                                className='dropdown-item cursor'
                                                onClick={() => {
                                                  setShowAddImportDistrict(
                                                    !showAddImportDistrict
                                                  )
                                                  setSelectedStateId(data?.id)
                                                  setSheetIndex(i)
                                                }}
                                              >
                                                Import Districts
                                              </a>
                                            ) : (
                                              <></>
                                            )} */}
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                    }
                                                                                </tr>
                                                                            </>
                                                                        )
                                                                    })}
                                                            </tbody>
                                                        </table>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className='text-center'>
                                                            <img width={'25%'} src={NoDataImg}></img>
                                                            <br />
                                                            <label style={{ fontWeight: 'bold' }}>
                                                                {LOADING_ENABLE ? (
                                                                    <>Loading Data.....</>
                                                                ) : (
                                                                    <>No Data Found</>
                                                                )}
                                                            </label>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                            {datalist && datalist.length > 0 ? (
                                                <div className='card-footer py-4'>
                                                    <Box
                                                        display='flex'
                                                        justifyContent='right'
                                                        alignItems='center'
                                                    >
                                                        <span>Total record: {pagerecord?.totalItems}</span>
                                                        <Pagination
                                                            className='custom-pagination-class'
                                                            count={pagerecord?.totalPages}
                                                            page={page}
                                                            onChange={handleChange}
                                                            color='secondary'
                                                        />
                                                    </Box>
                                                </div>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (<InsufficientPermission />)
                }
            </div>
        </>
    )
}